<template>
  <div>
    <Toast />

    <div class="card">
      <h5>
        <b>Detail Permintaan Barang Obral</b>
      </h5>
      <div class="p-grid">
        <div class="p-col p-mb-5">
          <label>Nomor Bon</label>
          <div>{{ summary.doc_number }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label>Tanggal Bon</label>
          <div>{{ moment(summary.doc_date).format('DD-MM-YYYY') }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label>Status</label>
          <div>
            <span :style="summary.status === 1 ? 'color:green' : 'color:red'">
              <b> {{ checkStatus(summary.status) }}</b>
            </span>
          </div>
        </div>

        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Kode Kategori</th>
                <th>Kode Supplier</th>
                <th>Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items" :key="k">
                <td>{{ k + 1 }}</td>
                <td>{{ an_item.item_code }}</td>
                <td>{{ an_item.item_name }}</td>
                <td>{{ an_item.category_code }}</td>
                <td>{{ an_item.supplier_code }}</td>
                <td>{{ an_item.qty }}</td>
                <td v-if="an_item.status != 1 && user.role == 'RETURN'">
                  <button
                    class="btn btn-primary"
                    @click="onApproveBtnClick(an_item)"
                  >
                    Disetujui
                  </button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label>Total Qty:</label>
                </td>
                <td>{{ summary.total_qty }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <button
          class="btn btn-primary"
          @click="onApproveBtnClick(an_item)"
          v-if="items[0].status === 0"
        >
          Disetujui
        </button> -->

        <Dialog
          :visible.sync="ShowApproveConfirmation"
          :style="{ width: '450px' }"
          header="Approve Receiving"
          :modal="true"
        >
          <div class="confirmation-content">
            <span> Apakah kamu yakin ingin mengkonfimasi barang ini ? </span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="ShowApproveConfirmation = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check "
              class="p-button-text"
              @click="onConfirmApprove()"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment: moment,
      loading: true,
      products: null,
      expandedRows: [],
      summary: {},
      outlet_inbounds: null,
      ShowApproveConfirmation: false,
      outlet_inbound_data: null,
      items: null
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.loading = false
    this.getOutlets()
    this.getListBarangObral()
  },
  methods: {
    onApproveBtnClick(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.ShowApproveConfirmation = true
    },

    // onConfirmApprove() {
    //   this.$http
    //     .patch(
    //       `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales/approved?doc_number=${this.$route.query.doc_number}`
    //     )
    //     .then(response => {
    //       if (response.status === 200) {
    //         this.$toast.add({
    //           severity: 'success',
    //           summary: 'Approvement success',
    //           detail: 'This item is approved successfully',
    //           life: 3000
    //         })
    //         this.ShowApproveConfirmation = false
    //         this.getOutlets()
    //       } else {
    //         this.$toast.add({
    //           severity: 'error',
    //           summary: 'Aprrovement failed',
    //           detail: 'There is a problem in during approving the item',
    //           life: 3000
    //         })
    //         return false
    //       }
    //     })
    // },

    checkStatus(status) {
      if (status == 0) {
        // return Pending merah
        return 'Tertunda'
      } else if (status == 1) {
        // return Confirmed Hijau
        return 'Disetujui'
      } else {
        return 'Diproses'
      }
    },

    onConfirmApprove() {
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales/${this.outlet_inbound_data.id}/approved`
        )
        .then(response => {
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Approvement success',
              detail: 'This item is approved successfully',
              life: 3000
            })
            this.ShowApproveConfirmation = false
            this.getOutlets()
            setTimeout(() => {
              this.$router.go()
            }, 1000)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Aprrovement failed',
              detail: 'There is a problem in during approving the item',
              life: 3000
            })
            return false
          }
        })
    },

    getOutlets() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales/outgoing?doc_number=${this.$route.query.doc_number}`
        )
        .then(response => {
          if (response.status === 200) {
            this.summary = response.data.data.summary
            this.outlet_inbounds = response.data.data.warehouse_sales
          }
        })
    },
    getListBarangObral() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-sales?doc_number=${this.$route.query.doc_number}`
        )
        .then(response => {
          this.loading1 = false
          if (response.status === 200) {
            this.items = response.data.data.warehouse_sales
          } else {
            console.error('gagal get')
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
